
export default {
  search: "Buscar",
  searchPlaceholder: "Buscar productos...",
  scanProduct: "Escanear Producto",
  useCamera: "Usar Cámara",
  capture: "Capturar",
  scanInstructions: "Toma una foto o sube una imagen del producto",
  matchingProducts: "Productos Coincidentes",
  noMatch: "No se encontraron coincidencias",
  noMatchDescription: "No encontramos productos que coincidan con esta imagen",
  searchManually: "Buscar Manualmente",
  addNewProduct: "Agregar Nuevo Producto",
  detectedText: "Texto Detectado",
  detectedInfo: "Información Detectada del Producto",
  name: "Nombre",
  brand: "Marca",
  description: "Descripción",
  volume: "Volumen",
  ingredients: "Ingredientes",
  price: "Precio",
  rating: "Calificación",
  review: "Reseña",
  reviews: "Reseñas",
  shareExperience: "Comparte tu experiencia con este producto",
  purchaseLocation: "Lugar de Compra",
  whereBought: "¿Dónde compraste este producto?",
  createProduct: "Crear Producto",
  productCreated: "Producto Creado",
  productCreatedSuccess: "El producto ha sido creado exitosamente",
  noResults: "No se encontraron resultados para '{{query}}'",
  searchResults: "Resultados de Búsqueda",
  allProducts: "Todos los Productos",
  addDirectly: "Agregar Producto Directamente",
  chooseImage: "Elegir Imagen",
  noScansYet: "Aún no hay historial de escaneos",
  recentScans: "Escaneos Recientes",
  scanAgain: "Escanear de Nuevo",
  viewProduct: "Ver Producto",
  addProduct: "Agregar Producto",
  weFoundText: "Hemos detectado texto en tu producto. Puedes crear un nuevo producto con esta información.",
  textDetected: "Texto Detectado",
  noProductFound: "No se encontró el producto. Puedes agregarlo a nuestra base de datos.",
  productFound: "¡Producto encontrado en nuestra base de datos!",
  scanComplete: "Escaneo Completado"
};
